type TooltipSession = {
  dismiss?: () => void;
  closedAt: number;
};

// A document owns one help-tooltip session. Weak keys keep frames/pages independent
// and avoid sharing interaction state between server-rendered requests.
const sessions = new WeakMap<Document, TooltipSession>();
const getSession = (document: Document) => {
  let session = sessions.get(document);
  if (!session) {
    session = { closedAt: -Infinity };
    sessions.set(document, session);
  }
  return session;
};

export const isTooltipSessionWarm = (document: Document) => {
  const session = getSession(document);
  return !!session.dismiss || Date.now() - session.closedAt < 300;
};

export const claimTooltipSession = (document: Document, dismiss: () => void) => {
  const session = getSession(document);
  if (session.dismiss === dismiss) return;
  const previous = session.dismiss;
  session.dismiss = dismiss;
  previous?.();
};

export const releaseTooltipSession = (document: Document, dismiss: () => void) => {
  const session = getSession(document);
  if (session.dismiss !== dismiss) return;
  session.dismiss = undefined;
  session.closedAt = Date.now();
};
